// extracted by mini-css-extract-plugin
export default {"container":"container__2ucky","fitToContainer":"fitToContainer__1nOIj"};